wp.hooks.addFilter( 'helpgent_core_app_router', 'directorist-helpgent-integration', function( router, args ) {
	return args.HashRouter;
}, 10 );

wp.hooks.addFilter( 'helpgent_core_app_routes', 'directorist-helpgent-integration', function( routes, args ) {
	const { Provider, messengerStore, Messenger, formStore, Forms, formBuilderStore, FormBuilder } = args;

	routes.push( {
		path: '/hg_messages',
		element: <Provider store={ messengerStore }><Messenger /></Provider>
	} );

	routes.push( {
		path: '/hg_forms',
		element: <Provider store={ formStore }><Forms /></Provider>
	} );

	routes.push( {
		path: '/hg_forms/edit/:id',
		element: <Provider store={ formBuilderStore }><FormBuilder /></Provider>
	} );

	return routes;
}, 10 );